/**
 * Google Maps Handler Module
 */

const handleMap = (mapElement) => {
	// Function to initialize the map once Google Maps API is loaded
	const initializeMap = () => {
		const styles = [
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [{ "color": "#444444" }]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [{ "color": "#f2f2f2" }]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [{ "saturation": -100 }, { "lightness": 45 }]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [{ "visibility": "simplified" }]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [{ "visibility": "off" }]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [{ "color": "#cbcbcb" }, { "visibility": "on" }]
			}
		];

		const lng = parseFloat(mapElement.dataset.lng);
		const lat = parseFloat(mapElement.dataset.lat);

		if (isNaN(lat) || isNaN(lng)) {
			console.warn('Invalid map coordinates');
			return;
		}

		const mapOptions = {
			zoom: 15,
			styles,
			center: { lat, lng },
			mapTypeControl: false,
			fullscreenControl: false,
			disableDefaultUI: true,
		};

		const markerIcon = '/dist/assets/images/svg/ico-pin.svg';

		const map = new google.maps.Map(mapElement, mapOptions);
		const marker = new google.maps.Marker({
			position: new google.maps.LatLng(lat, lng),
			map: map,
			icon: markerIcon
		});
	};

	// More robust check for Google Maps API availability
	const isGoogleMapsReady = () => {
		return typeof google !== 'undefined' &&
			   google.maps &&
			   typeof google.maps.Map === 'function' &&
			   typeof google.maps.Marker === 'function';
	};

	// Check if Google Maps API is already loaded
	if (isGoogleMapsReady()) {
		initializeMap();
	} else {
		// Wait for Google Maps API to load with timeout protection
		let attempts = 0;
		const maxAttempts = 50; // 5 seconds max wait time

		const checkGoogleMaps = () => {
			attempts++;

			if (isGoogleMapsReady()) {
				initializeMap();
			} else if (attempts < maxAttempts) {
				// Check again after a short delay
				setTimeout(checkGoogleMaps, 100);
			} else {
				console.error('Google Maps API failed to load after 5 seconds');
			}
		};

		checkGoogleMaps();
	}
};

export default handleMap;
